module.exports = __webpack_public_path__ + "static/media/logoDashboard.3f26f381.png";